export default "__VITE_ASSET__ymVxVSOC__"